import React from "react";
import { useQuickSightAD  } from "@/hooks/useADReports";

const QuickSightADDashboard = () => {
  const { embedUrl } = useQuickSightAD ();

  return (
    <div className="quicksight-container">
      <iframe
        title="QuickSight Dashboard"
        width="100%"
        height="800px"
        src={embedUrl}
        frameBorder="0"
        allowFullScreen
        className="border rounded-lg"
      />
    </div>
  );
};

export default QuickSightADDashboard;
